import React from 'react';
import PropTypes from 'prop-types';

import { UilTimes } from '@iconscout/react-unicons';
import { Button } from '../atoms';

const ModalDialog = (props) => {
  const {
    isMobile,
    mobile,
    show,
    close,
    large,
    small,
    alert,
    custom,
    children,
    secondaryAction,
    primaryAction,
    primaryDisabled,
    title = 'Text modal title',
    secondaryVariant = 'transparent',
    primaryVariant = 'primary',
    primaryTheme = 'blue-hedgehog',
    secondaryTheme = 'blue-hedgehog',
    primaryTitle = 'Primary action',
    secondaryTitle = 'Secondary action',
    footer = true,
    loading = false,
    footerUnit,
    primaryClassname,
  } = props;

  const size =
    (large && 'w-modal-large h-modal-default') ||
    (small && 'w-modal-small h-modal-default') ||
    (alert && 'w-modal-small h-modal-alert') ||
    (custom && 'w-modal-small') ||
    (mobile && 'max-w-md w-full') ||
    '';

  return (
    <>
      {show && (
        <div
          onClick={close}
          className={`fixed left-0 top-0 right-0 bottom-0 bg-neutral-dark opacity-50 duration-300 transition-all w-screen h-screen`}
          style={{ zIndex: 1000 }}
        ></div>
      )}

      <div
        className={`bg-neutral-light fixed  left-1/2 flex flex-col justify-between mx-auto duration-700 ease-in-out transition-all ${
          !isMobile ? 'transXY' : 'transXYMobile'
        } rounded-lg  ${size}`}
        style={
          show
            ? isMobile
              ? { zIndex: 1001, bottom: 0 }
              : { zIndex: 1001, top: '50%' }
            : isMobile
            ? { zIndex: 1001, bottom: '-200%' }
            : { zIndex: 1001, top: '-200%' }
        }
      >
        {/* HEADER MODAL */}
        <div className="w-full relative flex justify-center items-center rounded-t-lg border-b border-gray-culture p-3">
          <span className="absolute left-1">
            <Button action={close} content="icon-only" variant="transparent" icon={<UilTimes color="#8F8F8F" />} />
          </span>

          <p className="heading-3">{title}</p>
        </div>

        {/* CONTENT MODAL */}
        <div className="w-full h-full relative overflow-y-scroll p-4">{children}</div>
        {/* <div className="w-full h-modal-alert-content p-3">aaaaaaaa aaaaaaaa aaaaaaaa aaaaaaaa aaaaaaaa aaaaaaaa</div> */}

        {/* FOOTER MODAL */}
        {footer && (
          <div className="flex justify-between p-3 border-t border-gray-culture">
            {secondaryAction ? (
              <Button className="bold-text-2" action={secondaryAction} variant={secondaryVariant} theme={secondaryTheme}>
                {secondaryTitle}
              </Button>
            ) : (
              <span></span>
            )}

            {footerUnit ? (
              <div className="flex justify-between items-center">
                <span className="bold-text-2 mr-3">{footerUnit}</span>

                <Button
                  className={primaryClassname}
                  disabled={primaryDisabled}
                  loading={loading}
                  action={primaryAction}
                  variant={primaryVariant}
                  theme={primaryTheme}
                >
                  {primaryTitle}
                </Button>
              </div>
            ) : (
              <Button
                isBlock={isMobile}
                className={primaryClassname}
                disabled={primaryDisabled}
                loading={loading}
                action={primaryAction}
                variant={primaryVariant}
                theme={primaryTheme}
              >
                {primaryTitle}
              </Button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

ModalDialog.propTypes = {
  small: PropTypes.bool,
  large: PropTypes.bool,
  alert: PropTypes.bool,
  show: PropTypes.bool,
  close: PropTypes.func,
  primaryAction: PropTypes.func,
  secondaryAction: PropTypes.func,
  primaryTitle: PropTypes.string,
  secondaryTitle: PropTypes.string,
  primaryVariant: PropTypes.string,
  secondaryVariant: PropTypes.string,
  footerUnit: PropTypes.string,
  primaryTheme: PropTypes.string,
  secondaryTheme: PropTypes.string,
  primaryClassname: PropTypes.string,
  footer: PropTypes.bool,
  loading: PropTypes.bool,
  primaryDisabled: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default ModalDialog;
